export default "__VITE_ASSET__CXV$qwc5__"